import React, { Component } from 'react';
import { Dropdown } from 'primereact/components/dropdown/Dropdown';
import './Select.styles';

class Select extends Component {
  onChange = ({ value }) => {
    this.props.onChange(value);
  };

  render() {
    const {
      options,
      placeholder,
      onChange,
      value,
      readOnly,
      ...rest
    } = this.props;
    return (
      <div>
        <Dropdown
          {...rest}
          autoWidth={false}
          scrollHeight="123px"
          disabled={readOnly}
          value={value}
          options={options || []}
          onChange={this.onChange}
          placeholder={placeholder}
          // appendTo={document.body}
        />
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/inputs/select/Select.js